import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['handle'];

  start(event) {
    event.preventDefault();
    this.startX = event.clientX;
    this.startWidth = this.element.offsetWidth;

    this.boundMove = this.move.bind(this);
    this.boundStop = this.stop.bind(this);

    this.overlay = document.createElement('div');
    this.overlay.style.cssText = [
      'position:fixed',
      'inset:0',
      'z-index:9999',
      'cursor:col-resize',
    ].join(';');
    document.body.appendChild(this.overlay);

    document.addEventListener('mousemove', this.boundMove);
    document.addEventListener('mouseup', this.boundStop);
  }

  move(event) {
    const delta = this.startX - event.clientX;
    const newWidth = Math.max(
      380,
      Math.min(this.startWidth + delta, window.innerWidth * 0.9),
    );
    this.element.style.setProperty('width', `${newWidth}px`, 'important');
  }

  stop() {
    if (this.boundMove) {
      document.removeEventListener('mousemove', this.boundMove);
      document.removeEventListener('mouseup', this.boundStop);
    }
    this.overlay?.remove();
    this.overlay = null;
  }

  disconnect() {
    this.stop();
  }
}
